let elem = document.querySelector(".carousel.product__image-slider");
let productThumbGallery;
let productMainGallery;

if (elem) {
  productThumbGallery = new Swiper(".carousel.product__image-thumbnail", {
    spaceBetween: 10,
    slidesPerView: "auto",
    watchSlidesProgress: true,
  });

  productMainGallery = new Swiper(".carousel.product__image-slider", {
    spaceBetween: 0,
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: ".product__image-slider-wrapper .swiper-button-next",
      prevEl: ".product__image-slider-wrapper .swiper-button-prev",
    },
    thumbs: {
      swiper: productThumbGallery,
    },
    mousewheel: {
      forceToAxis: true,
    },
  });
}
